import { Inject } from 'vue-di-container';
import { Component, Vue, Watch } from 'vue-property-decorator';

import WithRender from './breadcrumb.html';
// models
import { BreadCrumbModel } from '@/models/breadcrumb';
import UserModel from '@/models/user';
import UserService from '@/services/user';

@WithRender
@Component
export default class BreadCrumb extends Vue {
  @Inject(UserService)
  public userService!: UserService;

  public showBreadCrumb = false;
  public user: UserModel = {} as UserModel;

  public baseBreadcrumb: BreadCrumbModel[] = [];
  public breadcrumbs: BreadCrumbModel[] = this.baseBreadcrumb;

  public get isLoggedInUser() {
    return Object.keys(this.user).length > 0;
  }

  public get isHighlighted() {
    const { path, meta } = this.$route;
    const dynamicallyHighlightedFromRouter = meta?.highlighted || false;
    const highlightedRoutes: string[] = [];

    return highlightedRoutes.includes(path.toLocaleLowerCase()) || dynamicallyHighlightedFromRouter;
  }

  public get pageTitle() {
    const { pageTitle } = this.$route.meta || {};

    return pageTitle ? this.$t(pageTitle).toString() : '';
  }

  public get pageDescription() {
    const { pageDescription } = this.$route.meta || {};

    return pageDescription ? this.$t(pageDescription).toString() : '';
  }

  async mounted() {
    this.user = await this.userService.getUser();

    this.appendDynamicBreadcrumbs();
  }

  public appendDynamicBreadcrumbs() {
    const { isLoggedInUser } = this;
    const requiredText = isLoggedInUser ? 'dashboard' : 'home';
    const requiredApp = isLoggedInUser ? 'dashboard' : 'landing';

    const initialBreadCrumbs = [
      {
        external: true,
        text: this.$t(requiredText).toString(),
        href: `/applications/${requiredApp}`,
      },
      {
        external: true,
        text: this.$t('electronicServices').toString(),
        href: '/applications/help-connect/e-services',
      },
      {
        external: true,
        text: this.$t('verificationServices').toString(),
        href: window.$config.verificationServiceLink,
      },
    ];

    this.breadcrumbs = [...initialBreadCrumbs];
    this.baseBreadcrumb = [...initialBreadCrumbs];

    this.updateBreadCrumbs();
  }

  @Watch('$route')
  public updateBreadCrumbs() {
    this.showBreadCrumb = this.$route.fullPath !== '/';

    let enhancedBreadcrumbs: BreadCrumbModel[] = [...this.baseBreadcrumb];

    this.$route.matched.forEach((route) => {
      const hasBreadcrumb = 'breadcrumb' in route.meta;

      if (hasBreadcrumb) {
        enhancedBreadcrumbs = enhancedBreadcrumbs.concat(route.meta.breadcrumb);
      } else {
        enhancedBreadcrumbs = [...this.baseBreadcrumb];
      }
    });

    // ? update [disabled/external] prop
    this.breadcrumbs = enhancedBreadcrumbs.map((route, index) => ({
      ...route,
      external: route.external || false,
      disabled: index === (enhancedBreadcrumbs.length - 1),
    }));
  }

  public onClickBreadcrumb(route: BreadCrumbModel) {
    this.$router.push(route.href);
  }
}
